import { I18nContext } from 'contexts/I18n/I18nProvider';
import Card from 'core/card';
import NoRecords from 'core/no-records/no-records-container';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AnonymizerBody from './components/AnonymizerBody';
import ServicesHeader from './components/ServicesHeader';
import { resetService } from './redux/service/actions';
import { CreateServiceFunction, DeleteHashFunction, DeleteServiceFunction, FetchAllServicesFunction, FetchHashByAidFunction, FetchHashByIdFunction, HashType, ServiceType, UpdateServiceFunction } from './types';

interface AnonymizerProps {
  service: ServiceType | number
  services: Array<ServiceType>
  hash: HashType
  fetchAllServices: FetchAllServicesFunction
  createService: CreateServiceFunction
  updateService: UpdateServiceFunction
  deleteService: DeleteServiceFunction
  fetchHashById: FetchHashByIdFunction
  fetchHashByAid: FetchHashByAidFunction
  deleteHashById: DeleteHashFunction
}

export default function Anonymizer({ service, fetchAllServices, services, createService, deleteService, updateService, fetchHashById, fetchHashByAid, deleteHashById, hash }: AnonymizerProps) {
  const t = useContext(I18nContext)
  const dispatch = useDispatch()

  useEffect(() => {
    fetchAllServices()
    return () => {
      dispatch(resetService())
    }
  }, [])

  return (
    <div className="tile is-parent">
      <div className="tile is-child">
        <Card>
          <ServicesHeader selected={service} services={services} createService={createService} />
          {typeof (service) !== 'number' ?
            <AnonymizerBody
              service={service}
              hash={hash}
              updateService={updateService}
              deleteService={deleteService}
              fetchHashById={fetchHashById}
              fetchHashByAid={fetchHashByAid}
              deleteHash={deleteHashById} /> :
            <NoRecords subtitle={t('anonymizer.select_service_subtitle')} />}
        </Card>
      </div>
    </div>
  )
}
